const FUNCTIONS_BASE_URL =
  process.env.REACT_APP_FUNCTIONS_URL ||
  'https://europe-west2-qrproperties.cloudfunctions.net';

const AGENCIES_CACHE_MS = 10 * 60 * 1000;

let memoryCache = { snapshot: null, loadedAt: 0 };
let inFlight = null;

function snapshotFromAgencies(agencies) {
  const docs = (agencies || []).map((row) => ({
    id: String(row.id || row.agencyId || ''),
    data: () => ({ ...row }),
  }));
  return { docs };
}

async function fetchAgenciesViaFunctions() {
  const response = await fetch(`${FUNCTIONS_BASE_URL}/listAgenciesPublic`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: '{}',
  });
  if (!response.ok) {
    throw new Error(`agencies_fn_${response.status}`);
  }
  const payload = await response.json();
  return snapshotFromAgencies(payload.agencies || []);
}

/**
 * Public agency directory via Cloud Functions.
 * Returns Firestore-like snapshot: `{ docs: [{ id, data() }] }`.
 */
export async function fetchAgenciesSnapshot() {
  const now = Date.now();
  if (memoryCache.snapshot && now - memoryCache.loadedAt < AGENCIES_CACHE_MS) {
    return memoryCache.snapshot;
  }

  if (!inFlight) {
    inFlight = fetchAgenciesViaFunctions()
      .then((snapshot) => {
        memoryCache = { snapshot, loadedAt: Date.now() };
        return snapshot;
      })
      .catch((err) => {
        if (memoryCache.snapshot) return memoryCache.snapshot;
        throw err;
      })
      .finally(() => {
        inFlight = null;
      });
  }

  return inFlight;
}

export function clearAgenciesSnapshotCache() {
  memoryCache = { snapshot: null, loadedAt: 0 };
}
